
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt, FaTruck, FaTshirt, FaRulerCombined, FaRuler } from 'react-icons/fa'
import { FaMoneyBillWave } from 'react-icons/fa6'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import './ListProductRow.css'

import EditProduct from '../EditProduct'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


function ListProductRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess, handleOnSelected, itemData, enableSelectRow }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditProduct, setModalEditProduct] = useState(false)
    const [productId, setProductId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [productName, setProductName] = useState("")

    /* Selected item */
    const [selectedItem, setSelectedItem] = useState(itemData || {})

    const handleSelected = (item) => {
        if (enableSelectRow) {
            setSelectedItem(item)
            handleOnSelected(item)
        }
    }

    async function deleteProduct(id) {
        let msgType = 'success'
        const data = await api.delete(`/product/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div
                    key={item._id}
                    className={`pg-item ${enableSelectRow ? 'pg-item-selectable' : ''} ${enableSelectRow && selectedItem._id === item._id ? 'pg-item-selected' : ''}`}
                    onClick={() => handleSelected(item)}
                >
                    <div className='pg-item-main'>
                        <div className='product-row-text'>
                            <span className='product-row-name'>{item.description}</span>
                            <div className='product-row-meta'>
                                <span className='product-row-code'>#{item.code}</span>
                                {item.category?.name && (
                                    <span className='product-category-badge'>{item.category.name}</span>
                                )}
                                {item.sex?.label && (
                                    <span className='product-sex-badge'>{item.sex.label}</span>
                                )}
                            </div>
                            <div className='product-row-links'>
                                {item.provider?.name && (
                                    <span className='product-row-link-item'><FaTruck size={11} />{item.provider.name}</span>
                                )}
                                {item.cloth?.name && (
                                    <span className='product-row-link-item'><FaTshirt size={11} />{item.cloth.name}</span>
                                )}
                                {item.sizeGrid?.name && (
                                    <span className='product-row-link-item'><FaRulerCombined size={11} />{item.sizeGrid.name}</span>
                                )}
                                {item.measure && item.unit?.value && (
                                    <span className='product-row-link-item'><FaRuler size={11} />{item.measure} {item.unit.value}</span>
                                )}
                                {item.totalInCash && (
                                    <span className='product-row-price'><FaMoneyBillWave size={11} />R$ {item.totalInCash} à vista</span>
                                )}
                            </div>
                        </div>
                    </div>

                    {!enableSelectRow && (
                        <div className='shd-row-box-item-action'>
                            {myPermissionEdit &&
                                <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={(e) => { e.stopPropagation(); setProductId(item._id); setModalEditProduct(true) }} />
                            }
                            {myPermissionDelete &&
                                <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={(e) => { e.stopPropagation(); setModalDeleteItem(true); setProductId(item._id); setProductName(item.description) }} />
                            }
                        </div>
                    )}
                </div>
            ))
        }
    }

    return (
        <div>
            {listArray()}

            <Modal
                modalStatus={modalEditProduct}
                changeStatus={setModalEditProduct}
                t={2}
                w={96}
                h={94}
                content={
                    <EditProduct id={productId} handleOnSuccess={() => { setModalEditProduct(false); handleOnSuccess() }} btCancelAction={() => setModalEditProduct(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteProduct(productId)}
                message="Deseja realmente excluir esse produto?"
                itemName={productName}
            />

        </div>
    )
}

export default ListProductRow
